import { applyRtpPlaceholder, formatGameRtp, localizeConfig, type TranslateFn } from './localize'
import { resolveAssetUrls } from '@/utils/AssetsUrlUtil'

export type ConfigItem = Record<string, any>

const paytableConfig: ConfigItem[] = [
	{
		type: 'subtitle',
		subTitleCss: 'subTitle',
		align: 'left',
		additionalCss: 'cssclass',
		text: 'Paytable',
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'MAIN GAME',
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'HOLD AND WIN FEATURE',
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'cssclass',
		text: [
			'6 or more golden coin symbols triggers the Hold and Win feature.',
			'The golden coin credit values from Base game will stick to the window during the transition to the feature.',
			'The game starts with 3 re-spins. All golden coin credit symbols that land after each re-spin remain on the screen until the end of the re-spins.',
			'Every time a new golden coin lands on the reel, the number of re-spins are reset to 3.',
			'The game ends when no re-spins are remaining, or all the golden coin credit symbols are filled up and multiplied with total bet.',
			'If the player fills all 15 positions then they win the Mini Jackpot along with the sum of all credit values.',
			'The Jackpot values are:',
		],
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'roundListStyle',
		text: ['Mini – 50x total bet', 'Minor – 100x total bet', 'Major – 250x total bet', 'Grand - 1000x total bet'],
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'FREE GAME',
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'cssclass',
		text: [
			'3 Bonus symbols appearing on the base game screen awards 10 free spins.',
			'Free Spins can be re-triggered.  If 3 Bonus symbols appear on the screen during free game, then player will be awarded 10 additional free spins.',
			'6 or more Hold and Win symbols appearing on the Free Game screen awards the Hold and Win feature. The feature can be awarded maximum for 3 times during the free game',
			'Ladder feature is only available during Free Spins game.',
			'Up to 30 additional free spins can be retriggered.',
		],
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'LADDER FEATURE',
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'cssclass',
		text: [
			'During every free spin whenever player has 5 or less golden coin symbols appearing on screen, they are collected on the Ladder next to the reel.',
			'Keep accumulating the number of golden coin symbols and climb the Ladder throughout the Free Spins.',
			'At the end of the free game, the player gets the credit value corresponding to the accrued milestone.',
			'The Jackpot values are:',
		],
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'roundListStyle',
		text: ['Mini – 50x total bet', 'Minor – 100x total bet', 'Major – 250x total bet', 'Grand - 1000x total bet'],
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'WILD SYMBOL',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 500', '- 100', '- 50'],
		imgPath: '/assets/infopages/symbols/ww.png',
		imgName: 'ww.png',
		align: 'left',
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'cssclass',
		text: 'BUY FEATURE',
	},
	{
		type: 'image',
		imgCSS: 'image',
		align: 'center',
		additionalCss: 'splSymbol1',
		imgPath: '/assets/infopages/symbols/buyfeature.png',
		imgName: 'buyfeature.png',
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'cssclass',
		text: [
			'During the main game, the player will have an option to BUY BONUS.',
			'BUY BONUS price is 80x total bet.',
			'Buy Bonus feature guarantees entry into Free Spins feature.',
		],
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 500', '- 100', '- 50'],
		imgPath: '/assets/infopages/symbols/a.png',
		imgName: 'a.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 120', '- 60', '- 30'],
		imgPath: '/assets/infopages/symbols/b.png',
		imgName: 'b.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 60', '- 30', '- 15'],
		imgPath: '/assets/infopages/symbols/c.png',
		imgName: 'c.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 60', '- 30', '- 15'],
		imgPath: '/assets/infopages/symbols/d.png',
		imgName: 'd.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 40', '- 20', '- 10'],
		imgPath: '/assets/infopages/symbols/e.png',
		imgName: 'e.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 40', '- 20', '- 10'],
		imgPath: '/assets/infopages/symbols/f.png',
		imgName: 'f.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 20', '- 10', '- 5'],
		imgPath: '/assets/infopages/symbols/g.png',
		imgName: 'g.png',
		align: 'left',
	},
	{
		type: 'payouts',
		text1: ['x5', 'x4', 'x3'],
		text2: ['- 20', '- 10', '- 5'],
		imgPath: '/assets/infopages/symbols/h.png',
		imgName: 'h.png',
		align: 'left',
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'nextLine',
		text: 'Win Lines',
	},
	{
		type: 'image',
		imgCSS: 'image',
		align: 'center',
		additionalCss: 'splSymbol2',
		imgPath: '/assets/infopages/symbols/ptWinLines.png',
		imgName: 'ptWinLines.png',
	},
	{
		type: 'title',
		titleCss: 'title',
		align: 'center',
		additionalCss: 'nextLine',
		text: 'GAME RULES',
	},
	{
		type: 'list',
		align: 'left',
		listCss: 'listStyle',
		additionalCss: 'cssclass',
		text: [
			'The game is played with 20 fixed pay lines and each game costs 20 fixed coins.',
			'All Symbols pay from left to right in consecutive order.',
			'Payouts are made according to the pay table.',
			'Only the Highest win in the winning combination is paid.',
			'Malfunction voids all pays and plays.',
			'The max win limit the player can be awarded is 2000x bet. If there are remaining spins left, player will be awarded max win and round is forfeited.',
			'For this game, the long-term expected payback is {{RTP}}%.',
			'The RTP was calculated by simulating 10 million rounds.'
		],
	},
]

export const getPaytableConfig = (translate: TranslateFn, rtp?: unknown): ConfigItem[] =>
	resolveAssetUrls(applyRtpPlaceholder(localizeConfig(paytableConfig, translate), formatGameRtp(rtp)))
